import { Routes, Route } from "react-router-dom";
import ServiceGroupsListPage from "./list";
import AddServiceGroupPage from "./add";
import EditServiceGroupPage from "./edit";
import ViewServiceGroupPage from "./view";

function ServiceGroupsPage() {
	return (
		<Routes>
			<Route path="/" element={<ServiceGroupsListPage />} />
			<Route path="list" element={<ServiceGroupsListPage />} />
			<Route path="add" element={<AddServiceGroupPage />} />
			<Route path="/:id/edit" element={<EditServiceGroupPage />} />
			<Route path="/:id" element={<ViewServiceGroupPage />} />
		</Routes>
	);
}

export default ServiceGroupsPage;
